import React from 'react';
import {Navigate} from 'react-router-dom';
import {useAuth} from '../../features/auth';
import {commonStyles} from '../../shared/lib/styles';
import { AppDecorBackground } from '../../shared/ui';

export const PublicRoute = ({children}) => {
    const {isAuthenticated, loading} = useAuth();
    if (loading) {
        return (
            <div style={{ ...commonStyles.loadingContainer, position: 'relative', backgroundColor: 'transparent' }}>
                <AppDecorBackground />
                <div style={{ position: 'relative', zIndex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <div style={commonStyles.loadingSpinner} />
                    <p>Загрузка...</p>
                </div>
            </div>
        );
    }
    return !isAuthenticated ? children : <Navigate to="/dashboard"/>;
};

